import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.dev'
@Injectable()
export class ConfigurationService {

  private http: HttpClient;
  environment: any;
  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler); 
  }
  loadConfiguration() {
    this.environment = environment;
  }
  getConfiguration() {
   return this.environment;
  }
}
